function Cartcount() {
    let testCount = $('.grfq-quote-widget-container').attr('data-number-of-items');
    //console.log(test);
    $('.cart-count-bubble .add_count').text(testCount); 
}

$(document).on('click', '.product-form__quote', function() {
    setTimeout(function() {
        Cartcount();
        let cartIcon = $('.header__icon--cart');
        cartIcon.removeClass('cart-icon-animate');
        setTimeout(function() {
            cartIcon.addClass('cart-icon-animate');
            setTimeout(function() {
                cartIcon.removeClass('cart-icon-animate');
                setTimeout(function() {
                    cartIcon.addClass('cart-icon-animate');
                }, 300);
            }, 500);
        }, 50); 
        
    }, 700);
});

$(document).on('click', '.header-cart', function(e) {
    e.preventDefault();
  // console.log('click', $('.grfq-quote-widget-label'));
    $('.grfq-quote-widget-label').trigger('click');
});
$(document).on('click', '.grfq__popupForm__modal__close', function(e) {
     Cartcount()
});

$(window).on('load', function () {
       Cartcount()
 });


$(document).ready(function(){
  
    if($('.collection-hero__description').height() > 85){
      $('.coll-read-more-btn').show();
      $('.collection-hero__description').addClass('height-manage');
    }
    if($('.collection-hero__description').height() > 85){
      $('.coll-read-more-btn-2').show();
      $('.collection-hero__description').addClass('height-manage');
    }
    $('.coll-read-more-btn').click(function() {
        //var id = $(this).attr("data-id");
        if ($(this).parent().find('.collection-hero__description').hasClass("height-manage")){
          $(this).parent().find('.collection-hero__description').addClass('height-auto');
          $(this).parent().find('.collection-hero__description').removeClass('height-manage');
          $(this).text('View Less');
        } else{
          $(this).parent().find('.collection-hero__description').addClass('height-manage');
          $(this).parent().find('.collection-hero__description').removeClass('height-auto');
          $(this).text('View More');
        }
    });
    $('.coll-read-more-btn-2').click(function() {
        var id = $(this).attr("data-id");
        if ($(this).parent().find('.collection-hero__description').hasClass("height-manage")){
          $(this).parent().find('.collection-hero__description').addClass('height-auto');
          $(this).parent().find('.collection-hero__description').removeClass('height-manage');
          $(this).text('View Less');
        } else{
          $(this).parent().find('.collection-hero__description').addClass('height-manage');
          $(this).parent().find('.collection-hero__description').removeClass('height-auto');
          $(this).text('View More');
        }
        
    });
  
  if($('.dsgn-pck__block--question').length <= 0 ){
    $('.faq-coll-section').addClass('hidden');
  }  
});   

$(document).ready(function(){
  function Calculator(total_amount) {
     var total_amount = total_amount;
        var structure_percentage = 57;
        var surfacing_percentage = 20;
        var installation_percentage = 16;
        var freight_percentage = 7;

        var structure_price = total_amount * structure_percentage /100;
        var surfacing_price = total_amount * surfacing_percentage / 100;
        var installation_price = total_amount * installation_percentage /100;
        var freight_price = total_amount * freight_percentage /100;
        
        if(!isNaN(total_amount)){
            $('#structure_price').text('$' + structure_price.toFixed(2));
            $('#surfacing').text('$' + surfacing_price.toFixed(2));
            $('#installation').text('$' + installation_price.toFixed(2));
            $('#freight').text('$' + freight_price.toFixed(2));
        }else{
            $('#structure_price').text('$0');
            $('#surfacing').text('$0');
            $('#installation').text('$0');
            $('#freight').text('$0');
        }
  }
  $('#total_amount').on('input', function() {
     var total_amount= parseFloat($(this).val());
     Calculator(total_amount);
  });
  Calculator($('#total_amount').val());
});


